<template>
  <div>
   <p class="request-name">Your dicided idea</p>
   <div class="sub-preview-wrapper">
       <div class="sub-preview" v-if="val[0].img1"><img :src="val[0].img1"></div>
       <div class="sub-preview" v-if="val[0].img2"><img :src="val[0].img2"></div>
       <div class="sub-preview" v-if="val[0].img3"><img :src="val[0].img3"></div>
   </div>
   <p class="detail-title">Proposer</p>
   <router-link :to="{ name: 'account.index', params: {name: user.name } }">
     <div class="user">
       <div class="icon" v-if="user.icon_img" :style="`background-image: url(${user.icon_img})`">
       </div>
       <div class="user-info">
         <p class="user-id">{{ user.name }}</p>
         <p class="user-name">{{ user.screen_name }}</p>
       </div>
     </div>
   </router-link>
   <p class="detail-title">Price</p>
   <p class="detail-text">{{ val[0].price  + (tips? tips:0) }} + Stripe fee(3.6%) JPY</p>
   <p class="detail-title">State</p>
   <p class="detail-text">{{ val[0].state? lang[6] : lang[5]}}</p>
   <div class="btn-wrapper">
     <btn size="normal" type="primary" :label="lang[7]" @click="openPurchase"></btn>
   </div>
 </div>
</template>

<script>
import Btn from '../components/Button.vue'
import RequestPhase1LangMaster from '../masters/langMaster/RequestPhase1LangMaster'

export default {
  name: 'RequestPhase1',

  components:{
      Btn
  },

  props:[
     'val',
     'user',
     'tips'
  ],

  data() {
    return {
      lang: RequestPhase1LangMaster[this.$store.state.account.lang],
    }
  },

  methods:{
    openPurchase() {
      this.$parent.isPurchase = true
    },
  }

}
</script>



<style scoped>
a {
  color: #212529;
}

.sub-preview-wrapper {
 display: flex;
 overflow-x: scroll;
}

.request-name {
 font-size: 18px;
 font-weight: bold;
}

.detail-text, .-name {
  font-size: 12px;
}

.sub-preview {
  width: 100px;
  height: 100px;
  margin: 10px;
  background: #000;
}

.sub-preview img {
  width: inherit;
  height: inherit;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #F39939;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.user {
  display: flex;
  margin-bottom: 20px;
}

.user-info {
  margin: auto 10px;
}

.user-id {
  margin: 0;
  font-size: 12px;
}

.user-name {
  margin: 0;
  font-size: 16px;
}

.btn-wrapper {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

@media screen and (min-width: 800px){

  .request-name {
    font-size: 20px;
  }

  .detail-title {
    font-size: 18px;
  }

  .detail-text {
    font-size: 16px;
  }
}
</style>
